const toast = {
    success : (text = "") => {
        Toastify({
            text: text,
            duration: 1000,
            position: "right",
            style: {
                background: "#28a745",
                color: "white"
            }
        }).showToast();
    },
    error : (text = "") => {
        Toastify({
            text: text,
            duration: 3000,
            position: "right",
            style: {
                background: "#dc3545",
                color: "white"
            }
        }).showToast();
    }
}

export default toast;